/* eslint-disable max-len */

import { classnames, getQueryParam } from 'helpers/utils';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { goToPage, RouteName } from 'routes';
import { useEffect, useState } from 'react';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { UserController } from 'networking/controllers/user-controller';
import styles from './start-onboarding.module.scss';

const StartOnboarding: React.FC = () => {
  const email = getQueryParam('email') ?? '';
  const name = getQueryParam('name');
  const token = getQueryParam('token');
  const vaultId = getQueryParam('vault_id');
  const companyName = getQueryParam('company_name') ?? '';

  const [vaultTitle, setVaultTitle] = useState<string>('');

  const fetchVault = async () => {
    const response = await VaultsController.getVaultForInvite(
      Number(vaultId),
      token || '',
    );
    setVaultTitle(response.title);
  };

  useEffect(() => {
    fetchVault();
  }, [token]);

  const checkEmail = async () => {
    const activated = await UserController.isUserActive(email);
    if (activated) {
      goToPage(
        RouteName.SignInOnboarding,
        {},
        // The onboarding pages read vault_id.
        { email, name, token, vault_id: vaultId },
      );
    }
  };

  useEffect(() => {
    checkEmail();
  }, []);

  const onClik = () => {
    goToPage(
      RouteName.SignUpOnboarding,
      {},
      {
        email,
        name,
        token,
        vault_id: vaultId,
        companyName,
      },
    );
  };
  return (
    <div className={styles.container}>
      <div
        className={classnames(styles.containerTitle, 'text__heading3__gray800')}
      >
        <div className={styles.subtitle}>
          <div className={classnames(styles.title, 'text__heading3__gray800')}>
            <span>Welcome, {name}!</span>
            <span>
              {vaultTitle} <strong>Generational Story</strong> Awaits.
            </span>
          </div>
          <span className="text__body__semi__bold__large__gray700">
            Create a legacy that will stand the test of time.
          </span>
        </div>
        <Button
          buttonStyle={ButtonStyle.PrimaryFilled}
          buttonSize={ButtonSize.Medium}
          className={styles.button}
          onClick={onClik}
        >
          <span className="text__body__regular__medium__white">
            I&apos;m ready!
          </span>
        </Button>
      </div>
    </div>
  );
};

export { StartOnboarding };
